import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";
import { SignupOptions } from "Components/Transactions/Anonymous/SignUpOptions/SignupOptions";
import { Avatar, Box, Link, Stack, Typography } from "@mui/material";
import ceskoPlatiMobilemLogo from "Assets/Images/Images/cesko-plati-mobilem-logo.png";

const RESOURCES = Resources.Paypoint;

type Props = {
  owner: string;
  logoUrl?: string;
  affiliateCode?: string;
};

export const AnonymousUserContent = ({
  owner,
  logoUrl,
  affiliateCode,
}: Props) => {
  const { t } = useResource();

  return (
    <PrimaryPaper sx={{ maxWidth: 600 }}>
      <Stack alignItems="center" gap={3} py={1}>
        <Typography variant="h3" textAlign="center">
          {owner}
        </Typography>
        {logoUrl ? (
          <Avatar
            src={logoUrl}
            variant="rounded"
            sx={{ width: 200, height: 200 }}
          />
        ) : (
          <Box display="flex" justifyContent="center">
            <Link
              href="https://ceskoplatimobilem.cz/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <Box
                component="img"
                src={ceskoPlatiMobilemLogo}
                alt="Česko platí mobilem"
                sx={{ maxHeight: 60, width: "auto" }}
              />
            </Link>
          </Box>
        )}
        <Typography variant="h6" textAlign="center">
          {t(RESOURCES.IdlePaypointInfo)}
        </Typography>
      </Stack>
      <Box my={3}>
        <SignupOptions affiliateCode={affiliateCode} />
      </Box>
    </PrimaryPaper>
  );
};
